import * as PIXI from 'pixi.js';

export class Particle {
  private graphics: PIXI.Graphics;
  private vx: number;
  private vy: number;
  private life: number;

  constructor(x: number, y: number, color: number, container: PIXI.Container) {
    this.graphics = new PIXI.Graphics();
    const size = Math.random() * 2 + 1;
    this.graphics.rect(0, 0, size, size);
    this.graphics.fill(color);
    this.graphics.x = x;
    this.graphics.y = y;
    this.vx = (Math.random() - 0.5) * 2;
    this.vy = (Math.random() - 0.5) * 2;
    this.life = 1;
    container.addChild(this.graphics);
  }

  public update(): boolean {
    this.graphics.x += this.vx;
    this.graphics.y += this.vy;
    this.vx *= 0.98;
    this.vy *= 0.98;
    this.life -= 0.02;
    this.graphics.alpha = this.life;
    return this.life > 0;
  }

  public destroy(): void {
    if (this.graphics.parent) {
      this.graphics.parent.removeChild(this.graphics);
    }
    this.graphics.destroy();
  }
}
